import { render, staticRenderFns } from "./OrganizationalProposals.vue?vue&type=template&id=f25fa900"
import script from "./OrganizationalProposals.vue?vue&type=script&lang=js"
export * from "./OrganizationalProposals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports